"use client";
import * as c from "react";
import { a as T } from "./useRenderElement-B8V3_e8R.mjs";
import { u as l } from "./useEventCallback-CjuAhyNz.mjs";
import { u as E } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { C as _ } from "./CompositeListContext-DMgUtso4.mjs";
import { j as x } from "./jsx-runtime-CJ-St4mQ.mjs";
function y(f) {
  const {
    children: m,
    elementsRef: t,
    labelsRef: s,
    onMapChange: u
  } = f, p = c.useRef(0), i = T(L).current, o = T(D).current, [a, d] = c.useState(0), n = c.useRef(a), N = l((e, h) => {
    o.set(e, h ?? null), n.current += 1, d(n.current);
  }), O = l((e) => {
    o.delete(e), n.current += 1, d(n.current);
  }), r = c.useMemo(() => {
    const e = /* @__PURE__ */ new Map();
    return Array.from(o.keys()).sort(P).forEach((C, R) => {
      const g = o.get(C) ?? {};
      e.set(C, {
        ...g,
        index: R
      });
    }), e;
  }, [o, a]);
  E(() => {
    n.current === a && (t.current.length !== r.size && (t.current.length = r.size), s && s.current.length !== r.size && (s.current.length = r.size)), u == null || u(r);
  }, [u, r, t, s, a, n]);
  const I = l((e) => (i.add(e), () => {
    i.delete(e);
  }));
  E(() => {
    i.forEach((e) => e(r));
  }, [i, r]);
  const M = c.useMemo(() => ({
    register: N,
    unregister: O,
    subscribeMapChange: I,
    elementsRef: t,
    labelsRef: s,
    nextIndexRef: p
  }), [N, O, I, t, s, p]);
  return /* @__PURE__ */ x.jsx(_.Provider, {
    value: M,
    children: m
  });
}
function D() {
  return /* @__PURE__ */ new Map();
}
function L() {
  return /* @__PURE__ */ new Set();
}
function P(f, m) {
  const t = f.compareDocumentPosition(m);
  return t & Node.DOCUMENT_POSITION_FOLLOWING || t & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : t & Node.DOCUMENT_POSITION_PRECEDING || t & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
export {
  y as C
};
